import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { customerActions } from "@sonic/Store/GemecoState";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<
    {
        key: string;
        value: string;
    },
    DispatchProp<customerActions>
>;

export const DispatchSetFieldValue: HandlerType = props => {
    props.dispatch({
        type: "Components/DealerAccountRequestForm/SetFieldValue",
        key: props.parameter.key,
        value: props.parameter.value,
    });
};

export const chain = [DispatchSetFieldValue];

const setFieldValue = createHandlerChainRunner(chain, "SetFieldValue");
export default setFieldValue;
